export const FETCH_MY_ADDRESS = 'FETCH_MY_ADDRESS';
export const CHANGE_MY_ADDRESS = 'CHANGE_MY_ADDRESS';
export const ADD_MY_ADDRESS = 'ADD_MY_ADDRESS';
export const DELETE_MY_ADDRESS = 'DELETE_MY_ADDRESS';
export const EDIT_MY_ADDRESS='EDIT_MY_ADDRESS';
